import { NgModule } from '@angular/core';
import { ToolbarService } from './toolbar.service';
import { ToolbarComponent } from './toolbar.component';
import { SharedModule } from '../../shared/shared.module';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';

@NgModule({
  declarations: [ToolbarComponent],
  imports: [SharedModule, GalaxyPageModule, GalaxyTooltipModule],
  providers: [ToolbarService],
  exports: [ToolbarComponent],
})
export class ToolbarModule {}
